/* global common, TDPPaxMonthMenu */
import {
  byUserInteraction, formatNumberLocale, sendAmplitudeEvent, sendRequest,
} from '@html/_common/utils';

export const SELECTOR_PAX_MONTH_MENU_MONTH_ITEM = '.js-ao-pax-month-menu__months-grid-month';
export const SELECTOR_PAX_MONTH_MENU_BLOCK = '.js-ao-pax-month-menu__selector-block';
export const SELECTOR_PAX_MONTH_YEAR_PREV_BTN = '.js-ao-pax-month-menu__year-control-prev';
export const SELECTOR_PAX_MONTH_YEAR_NEXT_BTN = '.js-ao-pax-month-menu__year-control-next';
export const PAX_MONTH_YEAR_NEXT_BTN_DISABLED_CLASS = 'ao-pax-month-menu__selector-block-year-control-next--disabled';
export const PAX_MONTH_YEAR_PREV_BTN_DISABLED_CLASS = 'ao-pax-month-menu__selector-block-year-control-prev--disabled';
export const SELECTOR_MAIN = 'main';

const SELECTOR_HEADER_PAX = '.ao-header-pax-selector';

export default function AOPaxMonthMenu(persistSelection) {
  this.common = {};
  if (typeof sendAmplitudeEvent !== 'undefined') {
    this.common = {
      byUserInteraction,
      sendAmplitudeEvent,
      sendRequest,
    };
  } else {
    this.common = common;
  }
  this.persistSelection = persistSelection;

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  let activeYear = currentYear;

  let tdpModule;

  if (typeof sendAmplitudeEvent !== 'undefined') {
    import(/* webpackChunkName: "TDPPaxMonthMenu" */'@atomic/organisms/_common/pax-selector/month/menu/tdp-pax-month-menu').then((module) => {
      const TDPPaxMonthMenu = module.default;
      tdpModule = new TDPPaxMonthMenu();
    });
  } else {
    tdpModule = new TDPPaxMonthMenu();
  }

  const isTDPPage = () => {
    const pageType = $(SELECTOR_MAIN).attr('data-page-type');
    return pageType === 'TDP';
  };

  const waitForTdpModule = (callback, maxAttempts = 50, interval = 100) => {
    if (tdpModule) {
      callback();
      return;
    }

    let attempts = 0;
    const checkInterval = setInterval(() => {
      attempts += 1;
      if (tdpModule) {
        clearInterval(checkInterval);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
      }
    }, interval);
  };

  const isClickInHeader = (clickEvent) => $(clickEvent.target).closest(SELECTOR_HEADER_PAX).length > 0;

  function greyOutPastMonths() {
    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_BLOCK).each(function () {
      const yr = parseInt($(this).data('year'), 10);
      $(this)
        .find(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM)
        // eslint-disable-next-line func-names
        .each(function () {
          const $monthElement = $(this);
          $monthElement.removeClass('ao-pax-month-menu__months-grid-month--unavailable');
          const m = parseInt($monthElement.data('month'), 10);
          if (yr === currentYear && m < currentMonth) {
            $monthElement.addClass('ao-pax-month-menu__months-grid-month--unavailable');
          }
        });
    });
  }

  function updateView() {
    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_BLOCK).each(function () {
      $(this).toggleClass('ao-pax-month-menu__selector-block--active', parseInt($(this).data('year'), 10) === activeYear);
    });
  }

  const setActiveYear = (year) => {
    activeYear = year;
    updateView();
  };

  const updateYearButtonsVisibility = () => {
    $(SELECTOR_PAX_MONTH_YEAR_PREV_BTN)
      .toggleClass(PAX_MONTH_YEAR_PREV_BTN_DISABLED_CLASS, activeYear <= currentYear);
    $(SELECTOR_PAX_MONTH_YEAR_NEXT_BTN)
      .toggleClass(PAX_MONTH_YEAR_NEXT_BTN_DISABLED_CLASS, activeYear === currentYear + 2);

    if (isTDPPage()) {
      waitForTdpModule(() => {
        if (tdpModule) {
          tdpModule.updateNavigationState(activeYear);
        }
      });
    }
  };

  const handlePrevButtonClick = () => {
    $(SELECTOR_PAX_MONTH_YEAR_PREV_BTN).on('click', (event) => {
      const isTDPButtonLogic = isTDPPage() && !isClickInHeader(event);

      if ($(event.target).hasClass(PAX_MONTH_YEAR_PREV_BTN_DISABLED_CLASS)) {
        return;
      }

      // TDP override for non-header elements only
      if (isTDPButtonLogic) {
        waitForTdpModule(() => {
          if (tdpModule) {
            activeYear = tdpModule.handlePrevClick(activeYear, currentYear, setActiveYear);
          }
          updateYearButtonsVisibility();
        });
        return;
      }

      // Standard logic runs for ALL (header and non-header)
      if (!isTDPButtonLogic && activeYear > currentYear) {
        activeYear -= 1;
        updateView();
      }

      updateYearButtonsVisibility();
    });
  };

  const handleNextButtonClick = () => {
    $(SELECTOR_PAX_MONTH_YEAR_NEXT_BTN).on('click', (event) => {
      const isTDPButtonLogic = isTDPPage() && !isClickInHeader(event);

      if ($(event.target).hasClass(PAX_MONTH_YEAR_NEXT_BTN_DISABLED_CLASS)) {
        return;
      }

      // TDP override for non-header elements only
      if (isTDPButtonLogic) {
        waitForTdpModule(() => {
          if (tdpModule) {
            activeYear = tdpModule.handleNextClick(activeYear, currentYear, setActiveYear);
          }
          updateYearButtonsVisibility();
        });
        return;
      }

      // Standard logic runs for ALL (header and non-header)
      if (!isTDPButtonLogic && activeYear < currentYear + 2) {
        activeYear += 1;
        updateView();
      }

      updateYearButtonsVisibility();
    });
  };

  const sendAmplitudeData = (year, month, $monthElement) => {
    const dataPlacement = $monthElement.closest('.js-ao-pax-month').attr('data-placement') || $('.js-ao-pax-month-sheet').attr('data-placement');
    const eventName = $monthElement.closest('.js-ao-pax-month').attr('data-event-name') || $('.js-ao-pax-month-sheet').attr('data-event-name');

    this.common.sendAmplitudeEvent({
      ampEventName: eventName,
      selected_date: `${year}-${month}`,
      click_source: dataPlacement,
    });
  };

  const persistSelected = (month, year) => {
    if (this.persistSelection) {
      document.cookie = `pax_month_year=${month}-${year}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
    }
  };

  const handleMonthSelection = () => {
    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).on('click', function () {
      const $monthElement = $(this);

      if ($monthElement.hasClass('ao-pax-month-menu__months-grid-month--unavailable')) {
        return;
      }

      const month = $monthElement.attr('data-month');
      const monthName = $monthElement.attr('data-month-name');
      const year = $monthElement.closest(SELECTOR_PAX_MONTH_MENU_BLOCK).attr('data-year');

      // Immediate visual feedback - critical for perceived performance
      // Store reference to elements to ensure selection persists
      const $allMonthItems = $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM);
      const $matchingMonthItems = $(`.js-ao-pax-month-menu-month-${month}-${year}`);

      // Batch class changes to minimize layout recalculations
      // Only remove class from items that actually have it
      $allMonthItems.filter('.ao-pax-month-menu__months-grid-month--selected')
        .removeClass('ao-pax-month-menu__months-grid-month--selected');
      $monthElement.addClass('ao-pax-month-menu__months-grid-month--selected');
      $matchingMonthItems.not($monthElement)
        .addClass('ao-pax-month-menu__months-grid-month--selected');

      // Trigger event immediately so UI can update
      $(document).trigger('paxSelection:monthChange', { monthName, month, year });

      // Re-apply selection in next frame to ensure it persists after any DOM updates
      requestAnimationFrame(() => {
        // Ensure selection persists even if DOM was manipulated
        $allMonthItems.removeClass('ao-pax-month-menu__months-grid-month--selected');
        $monthElement.addClass('ao-pax-month-menu__months-grid-month--selected');
        $matchingMonthItems.addClass('ao-pax-month-menu__months-grid-month--selected');

        updateYearButtonsVisibility();
      });

      setTimeout(() => {
        persistSelected(month, year);
        sendAmplitudeData(year, month, $monthElement);
      }, 0);
    });
  };

  const checkMonthsCookies = () => {
    const cookie = document.cookie.split('; ').find((row) => row.startsWith('pax_month_year='));
    if (cookie) {
      const [month, year] = cookie.split('=')[1].split('-');
      const parsedYear = Number.isNaN(parseInt(year, 10)) ? null : parseInt(year, 10);
      const parsedMonth = Number.isNaN(parseInt(month, 10)) ? null : parseInt(month, 10);

      // Check if the month is a past month
      if (parsedYear === null
        || parsedMonth === null
        || parsedYear < currentYear
        || (parsedYear === currentYear && parsedMonth < currentMonth)) {
        return;
      }

      activeYear = parsedYear;
      updateView();

      // eslint-disable-next-line func-names
      $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).each(function () {
        const $monthElement = $(this);
        if ($monthElement.attr('data-month') === month && $monthElement.closest(SELECTOR_PAX_MONTH_MENU_BLOCK).attr('data-year') === year) {
          $monthElement.addClass('ao-pax-month-menu__months-grid-month--selected');
          const monthName = $monthElement.attr('data-month-name');
          const monthNumber = $monthElement.attr('data-month');
          $(document).trigger('paxSelection:monthChange', { monthName, month: monthNumber, year });
        }
      });

      // TDP override for non-header elements only
      if (isTDPPage()) {
        waitForTdpModule(() => {
          if (tdpModule) {
            activeYear = tdpModule.updateYearsVisibility(currentYear, activeYear, setActiveYear);
          }
          updateYearButtonsVisibility();
        });
      } else {
        updateYearButtonsVisibility();
      }
    }
  };

  const checkPageMonthData = (whereData) => {
    const [month, year] = whereData.split('-');
    const parsedYear = Number.isNaN(parseInt(year, 10)) ? null : parseInt(year, 10);
    const parsedMonth = Number.isNaN(parseInt(month, 10)) ? null : parseInt(month, 10);

    if (parsedYear === null
      || parsedMonth === null
      || parsedYear < currentYear
      || (parsedYear === currentYear && parsedMonth < currentMonth)) {
      return;
    }

    activeYear = parsedYear;
    updateView();

    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).each(function () {
      const $monthElement = $(this);
      if ($monthElement.attr('data-month') === month && $monthElement.closest(SELECTOR_PAX_MONTH_MENU_BLOCK).attr('data-year') === year) {
        $monthElement.addClass('ao-pax-month-menu__months-grid-month--selected');
        const monthName = $monthElement.attr('data-month-name');
        const monthNumber = $monthElement.attr('data-month');
        $(document).trigger('paxSelection:monthChange', { monthName, month: monthNumber, year });
      }
    });

    // TDP override for non-header elements only
    if (isTDPPage()) {
      waitForTdpModule(() => {
        if (tdpModule) {
          activeYear = tdpModule.updateYearsVisibility(currentYear, activeYear, setActiveYear);
        }
        updateYearButtonsVisibility();
      });
    } else {
      updateYearButtonsVisibility();
    }
  };

  const formatPrice = (price, currency) => {
    const numericPrice = parseFloat(price);
    const currencySymbols = {
      EUR: '€',
      USD: '$',
      GBP: '£',
      CAD: 'C$',
      AUD: 'A$',
    };

    const symbol = currencySymbols[currency] || currency;

    // Format with thousands separator, no decimal places
    const formattedNumber = formatNumberLocale(numericPrice, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return `${symbol}${formattedNumber}`;
  };

  const updateMonthPrices = (pricesData) => {
    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).each(function () {
      const $monthElement = $(this);

      // Skip if month element is inside sticky component or search
      if ($monthElement.closest('.ao-header-pax-selector__sticky-component--when, .ao-header-pax-selector__search').length > 0) {
        return;
      }

      const $priceElement = $monthElement.find('.js-ao-pax-month-menu__months-grid-month-price');
      const month = parseInt($monthElement.attr('data-month'), 10);
      const year = parseInt($monthElement.closest(SELECTOR_PAX_MONTH_MENU_BLOCK).attr('data-year'), 10);

      // Check if this month has already passed - if so, don't add prices
      if (year < currentYear || (year === currentYear && month < currentMonth)) {
        $priceElement.empty();
        return;
      }

      // Create date key in YYYY-MM-DD format (using 1st day of month)
      const dateKey = `${year}-${month.toString().padStart(2, '0')}-01`;

      if (pricesData[dateKey]) {
        const priceData = pricesData[dateKey];

        // Clear existing content
        $priceElement.empty();

        // Check if price is null - if so, allow selection but don't show price
        if (priceData.price === null) {
          $priceElement.addClass('hid');
        } else {
          // Format price with currency
          const formattedPrice = formatPrice(priceData.price, priceData.currency);

          // Handle discount
          if (parseFloat(priceData.discount) > 0) {
            // Show discounted price with discounted styling
            $priceElement.text(formattedPrice);
            $priceElement.addClass('ao-pax-month-menu__months-grid-month-price--discounted');
          } else {
            // No discount - just show regular price
            $priceElement.text(formattedPrice);
            $priceElement.removeClass('ao-pax-month-menu__months-grid-month-price--discounted');
          }

          // Show the price element
          $priceElement.removeClass('hid');
        }
      } else {
        $monthElement.addClass('ao-pax-month-menu__months-grid-month--unavailable');
      }
    });

    if (isTDPPage()) {
      waitForTdpModule(() => {
        if (tdpModule) {
          activeYear = tdpModule.updateYearsVisibility(currentYear, activeYear, setActiveYear);
        }
        updateYearButtonsVisibility();
      });
    } else {
      updateYearButtonsVisibility();
    }
  };

  const fetchMonthFromPrices = () => {
    const pageType = $(SELECTOR_MAIN).attr('data-page-type');
    const pageId = $(SELECTOR_MAIN).attr('data-id');
    if (pageType === 'TDP' && pageId) {
      this.common.sendRequest(
        `/api/tdp/best-price/all-months-prices/${pageId}`,
        null,
        (data) => {
          if (data && Object.keys(data).length > 0) {
            updateMonthPrices(data);
          }
        },
        { type: 'GET' },
      );
    }
  };

  this.initiate = () => {
    if ($('main').data('when')) {
      checkPageMonthData($('main').data('when'));
    } else {
      checkMonthsCookies();
    }
    greyOutPastMonths();
    handlePrevButtonClick();
    handleNextButtonClick();
    handleMonthSelection();
    this.common.byUserInteraction('fetch-from-prices', fetchMonthFromPrices);
  };
}
